import { render, staticRenderFns } from "./InfoAudience.vue?vue&type=template&id=8013d1dc&scoped=true&"
import script from "./InfoAudience.vue?vue&type=script&lang=js&"
export * from "./InfoAudience.vue?vue&type=script&lang=js&"
import style0 from "./InfoAudience.vue?vue&type=style&index=0&id=8013d1dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8013d1dc",
  null
  
)

export default component.exports